import { PageId } from 'constants/pages'

export const enum PageIdWoofzPt1 {
  DOG_SEX_PT1 = PageId.DOG_SEX_PT1,
  DOG_AGE_PT1 = PageId.DOG_AGE_PT1,
  SHELTER_PT1 = PageId.SHELTER_PT1,
  DOG_BREED_PT1 = PageId.DOG_BREED_PT1,
  URGE_PT1 = PageId.URGE_PT1,
  STARTED_PT1 = PageId.STARTED_PT1,
  PLACE_PT1 = PageId.PLACE_PT1,
  GOALS_PT1 = PageId.GOALS_PT1,
  ACCIDENTS_PT1 = PageId.ACCIDENTS_PT1,
  CONCERNS_PT1 = PageId.CONCERNS_PT1,
  URGE_2_PT1 = PageId.URGE_2_PT1,
  LIVING_SITUATION_PT1 = PageId.LIVING_SITUATION_PT1,
  POTTY_BREAKS_PT1 = PageId.POTTY_BREAKS_PT1,
  CRATE_TRAINING_PT1 = PageId.CRATE_TRAINING_PT1,
  BEHAVIOR_PT1 = PageId.BEHAVIOR_PT1,
  COMMANDS_PT1 = PageId.COMMANDS_PT1,
  TRAINING_TIME_PT1 = PageId.TRAINING_TIME_PT1,
  PREPARE_FLOW_PT1 = PageId.PREPARE_FLOW_PT1,
  COMMITMENT_SCREEN_PT1 = PageId.COMMITMENT_SCREEN_PT1,
  EMAIL_PT1 = PageId.EMAIL_PT1,
  NEWSLETTER_URGE_PT1 = PageId.NEWSLETTER_URGE_PT1,
  SUBSCRIPTIONS_PT1 = PageId.SUBSCRIPTIONS_PT1,
  CANCEL_OFFER_PT1 = PageId.CANCEL_OFFER_PT1,
  CHAT_UPSELL_PT1 = PageId.CHAT_UPSELL_PT1,
  UPSELL_PT1 = PageId.UPSELL_PT1,
  UPSELL_FEEDING_GUIDE_PT1 = PageId.UPSELL_FEEDING_GUIDE_PT1,
  UPSELL_EMOTIONAL_SUPPORT_PT1 = PageId.UPSELL_EMOTIONAL_SUPPORT_PT1,
  DOWNLOAD_PT1 = PageId.DOWNLOAD_PT1,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
